import { Component } from '@angular/core';
import { SampleUserService } from './sample-user.service';
import { SampleQuoteService } from './sample-quote.service';

@Component({
  selector: 'fc-sample-banner',
  templateUrl: 'sample-banner.html',
  styleUrls: ['sample-banner.scss'],
})
export class SampleBannerComponent {
  title = 'My Wonderful App';
  username = '';
  quote = '...';


  constructor(
    private sampleUserService:SampleUserService,
    private sampleQuoteService:SampleQuoteService,
    ) {
  }


  ngOnInit() {
    this.username = this.sampleUserService.username;

    this.sampleQuoteService.getQuote()
      .then(quote => this.quote = quote);
  }


}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/sample-banner/sample-banner.ts